import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Alert,
  Container,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Stack,
} from "@mantine/core";
import { useStore } from "../store";
import { setPassword } from "./authApi";
import { useLocation } from "wouter";
import { IconInfoCircle } from "@tabler/icons-react";

export default function ResetPassword({ params }) {
  const [, setLocation] = useLocation();
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const authToken = useStore((state) => state.authToken);
  const form = useForm({
    initialValues: {
      token: params.token,
      newPassword: "",
    },
    validate: {
      newPassword: (val) =>
        val.length < 8 ? "Password must be at least 8 characters" : null,
      // emailAddress: (val) => (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val) ? null : "Invalid email"),
    },
  });

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" fw={500}>
            You are logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  const errorIcon = <IconInfoCircle />;

  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Reset Failed"
          mb="lg"
          icon={errorIcon}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder>
        <Text size="lg" mb="lg" fw={500}>
          Set a New Password
        </Text>
        {/* 
        <Divider label="Reset Password" labelPosition="center" my="lg" /> */}

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setErrorMessage(null);

            setPassword({ ...values })
              .then((data) => {
                setIsFetching(false);
                setLocation("/auth/login");
              })
              .catch((err) => {
                setIsFetching(false);
                setErrorMessage("" + err);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              disabled={isFetching}
              label="New password"
              placeholder="A new password"
              value={form.values.newPassword}
              onChange={(event) =>
                form.setFieldValue("newPassword", event.currentTarget.value)
              }
              error={form.errors.newPassword}
              radius="md"
            />

            <Group justify="flex-end" mt="xl">
              <Button type="submit" radius="xl" loading={isFetching}>
                Set Password
              </Button>
            </Group>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
